import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";

const formatDeliveryNotes = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.deliveryNoteNumber}`,
		value: item._id,
		date: item.date && moment(item.date),
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

export const {
	fetch: fetchDeliveryNotes,
	create: createDeliveryNote,
	update: updateDeliveryNote,
	delete: deleteDeliveryNotes,
} = createCrudActions("DELIVERYNOTE", "Albarán", formatDeliveryNotes);
